import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';
import Link from 'flarum/common/components/Link';
export default class PostMovedPost extends EventPost {
  icon() {
    return 'fas fa-exchange-alt';
  }
  descriptionKey() {
    return 'fof-move-posts.forum.post_stream.post_moved';
  }
  descriptionData() {
    const post = this.attrs.post;
    const data = post.content();
    return {
      target_discussion: m(Link, {
        className: "EventPost-PostMoved-target",
        href: app.route('discussion.near', {
          id: data.targetDiscussionId,
          near: data.number
        })
      }, data.targetDiscussionTitle),
      count: data.count
    };
  }
}
flarum.reg.add('fof-move-posts', 'forum/components/PostMovedPost', PostMovedPost);